/**
 * @summary Contains the slider slide preact component
 */

/* globals loweL18n */

import { h, Component } from 'preact';
import Icon from './icon';
import decode from '../html-decode';

const $ = jQuery;

/**
 * @summary Slider slide preact component.
 *
 * @class
 * @extends {Component}
 */
export default class SliderSlide extends Component {
	constructor( props ) {
		super( props );

		this.imageAttributes = props.slide;
		this.imageAttributes.class = 'c-slide__image';

		// Split out image attributes to lazy-load the image on first shown
		this.imageLoadAttributes = {};
		[ 'src', 'srcset' ].forEach( name => {
			this.imageLoadAttributes[name] = this.imageAttributes[name];
			delete this.imageAttributes[name];
		});

		this.setRef = this.setRef.bind( this );
	}

	componentDidMount() {
		$().ready( () => {
			$( this.slide ).wc_product_gallery();
		});
	}

	/**
	 * @summary Generates an image loading placeholder.
	 *
	 * Sets the height of the area that the image will take up before it is
	 * loaded to pevent content jumps.
	 *
	 * @return {JSX} The placeholder div element.
	 */
	imageLoadingPlaceholder() {
		const imageSizeRatio = this.imageAttributes.height / this.imageAttributes.width;
		const style = {
			paddingTop: `${imageSizeRatio * 100}%`
		};

		return <div
			class="c-slide__load-scaffold"
			aria-hidden="true"
			style={style}
		/>;
	}

	setRef( element ) {
		this.slide = element;
	}

	/**
	 * @summary Gets HTML classes for this slide.
	 *
	 * @returns {string} The HTML class attribute string value.
	 */
	classes() {
		let stateClass = '';

		if ( this.props.state > 0 ) {
			stateClass = ' is-inactive-right';
		} else if ( this.props.state < 0 ) {
			stateClass = ' is-inactive-left';
		}
		return `c-slider__main-item ${stateClass}`;
	}

	imageGalleryAttributes() {
		return {
			style: 'display:none',
			'data-large_image': this.props.photoswipeData[0],
			'data-large_image_height': this.props.photoswipeData[2],
			'data-large_image_width': this.props.photoswipeData[1],
			'data-src': this.props.photoswipeData[0]
		};
	}

	render({ excerpt, link, title, state, photoswipeData }) {
		if ( state === 0 && ! ( 'src' in this.imageAttributes ) ) {
			this.imageAttributes = Object.assign(
				{},
				this.imageAttributes,
				this.imageLoadAttributes
			);
		}

		return (
			<div class={this.classes()}>
				<figure class="c-slide" ref={this.setRef}>
					<a href={link} title={loweL18n.viewLinkTitle}>
						{ this.imageLoadingPlaceholder() }
						<img {...this.imageAttributes}/>
					</a>

					<figcaption class="c-slide__caption">
						<h3 class="c-slide__title">{decode( title )}</h3>

						<div class="c-slide__icons">
							{photoswipeData &&
								<div class="woocommerce-product-gallery__image">
									<img {...this.imageGalleryAttributes()}/>
									<a href="#" class="c-slide__icon">
										<Icon
											icon="magnifying-glass"
											width="26"
											height="24"
											title={loweL18n.viewLargerVersion}
										/>
									</a>
								</div>
							}

							<a href={link} class="c-slide__icon">
								<Icon
									icon="cart"
									width="26"
									height="24"
									title={loweL18n.viewLinkTitle}
								/>
							</a>
						</div>

						<div class="c-slide__excerpt">{excerpt}</div>
					</figcaption>
				</figure>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/SliderSlide.js